<app-header></app-header>
<!-- breadcrumb section start -->
<section class="breadcrumb-section-main inner-2 breadcrumb-section-sm">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="breadcrumb-contain ">
          @if (product) {
            <div>
              <h2 class="breadcrumb-txt">{{product.name}}</h2>
            </div>
          }
          <div>
            <ul>

              @if (product) {
                <li><a class="white" href="javascript:void()">
                {{product.briefDescription}}</a>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</section>
<!--breadcrumb section end -->
<!-- section start -->
<ng-template #continueShoppingModal let-c="close" class="modal-dialog-centered" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Item added to basket</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">


    <div class="text-center">
      <a [routerLink]="['/express/basket']">
        <button type="button" class="btn btn-default primary-btn success back-white" >
          Checkout
        </button>
      </a>

      <button type="button" class="btn btn-default primary-btn danger"
        (click)="c('Close click')">Continue Shopping
      </button>

      @if (relatedProducts?.length) {
        <div>
          <h4 class="grey">You may also like:</h4>
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Image</th>
                <th scope="col">Product</th>
              </tr>
            </thead>
            <tbody>
              @for (product of relatedProducts; track product) {
                <tr>
                  <td><a [routerLink]="['/products/view', product.slug]">
                    <img [src]="product.mainImageAWSURL" class="card-img-top autofit modalimage">
                  </a>
                </td>
                <td> <h4><a [routerLink]="['/products/view', product.slug]">{{product.name }}</a></h4>
                <br />
                {{product.briefDescription}}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
</div>
</ng-template>

<ng-template #addToCartModal let-c="close" class="modal-dialog-centered" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">Add To Cart</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">


    <form class="form">
      <div class="form-group" [formGroup]="purchaseForm">
        <h6 class="product-title">Product</h6>
        <select class="form-control"
          formControlName="stockref">
          <option disabled selected value> --Select-- </option>
          @for (stockref of selectedImage.stockrefs; track stockref) {
            <option
            [ngValue]="stockref.id" >{{stockref.freeText}}</option>
          }
        </select>

        @if (selectedStockref) {
          <div>
            <br />
            @if (selectedStockref[0].width <= 1) {
            <h6 class="product-title">Quantity Required</h6><br />
            } @else {
                <h6 class="product-title">Size Required</h6><br />
            }
            <div class="input-group">
              @if (selectedStockref[0].width <= 1) {
                <input type="text" maxlength="3"
                  class="form-control fiftypercent" placeholder="Amount required?"
                  id="qty" inputmode="numeric" pattern="[0-9]*"   digitOnly
                  formControlName="qty">
              }
              @if (selectedStockref[0].width > 1.01) {
                <input type="text" maxlength="5"
                  class="form-control fiftypercent" placeholder="Amount required?"
                  id="qty" inputmode="numeric" digitOnly decimal="true"
                  formControlName="qty">
              }
              @if (stockrefPriceQ.price !== 0) {
                    <button class="btn btn-success"
                    (click)="addToCart()">Add</button>
                }
            </div>
          </div>
        }
      </div>
    </form>

    @if (selectedStockref) {
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
                @if (selectedStockref[0].width <= 1) {
                    <th scope="col">Pack Price</th>
                }
              
              <th scope="col">M2 Price</th>
              @if (selectedStockref[0].width > 1.01) {
                <th scope="col">Width</th>
              }
              @if (selectedStockref[0].width <= 1) {
                <th scope="col">Pack Size</th>
              }
            </tr>
          </thead>
          <tbody>
            <tr>
              @if (stockrefPriceQ) {
                @if (selectedStockref[0].width <= 1) {

                    <td>£ {{stockrefPriceQ.price }}</td>
                }
                
              }
              @if (stockrefPriceQ) {

                 @if (selectedStockref[0].width <= 1) {

                <td>
                  £ {{calculateSqmPrice(stockrefPriceQ.price, selectedStockref[0].packSize)}}
                </td>
                } @else {
                    <td>{{stockrefPriceQ.price }}</td>
                }
              }
              @if (selectedStockref[0].width > 1.01) {
                <td>{{selectedStockref[0].width}} m</td>
              }
              @if (selectedStockref[0].width <= 1) {
                <td>{{selectedStockref[0].packSize}} m2</td>
              }
            </tr>
          </tbody>
        </table>
        <br /><br />
      </div>
    }


  </div>
</ng-template>


@if (product) {
  <div class="agency">
    <section>
      <div class="collection-wrapper">
        <div class="container">
          <div class="row">
            <div class="col-12 col-xs-12">
              <div class="container-fluid">
                <div class="row">
                  @if (product.clearance) {
                    <div class="ribbon ribbon-top-right"><span>Limited Stock</span></div>
                  }
                  <div class="col-lg-6">
                    <h3 class="grey">{{product.name}}</h3>
                    <img class="img-product-detail"
                      [src]="imageCheck(product.mainImageAWSURL)" width="100%">
                    <div class="border-product">
                      <div [innerHTML]="product.wysiwyg"></div>
                    </div>
                  </div>
                  <div class="col-lg-6 rtl-text">
                    <div class="product-right">
                      @if (expressCustomer === true;) {
                        <div>
                          @if (expressAvailable) {
                            <div class="border-product">
                              <h6 class="product-title">Select a product</h6>
                              <form class="form">
                                <div class="form-group" [formGroup]="purchaseForm">
                                  <select class="form-control"
                                    formControlName="stockref">
                                    <option disabled selected value> --Select-- </option>
                                    @for (stockref of expressReferences; track stockref) {
                                      <option
                                      [ngValue]="stockref.id" >{{stockref.freeText}}</option>
                                    }
                                  </select>
                                  @if (selectedStockref) {
                                    <div>
                                      @if (selectedStockref[0].width > 1.01) {
                                        <h6 class="product-title">Size Required</h6>
                                      } @else {
                                        <h6 class="product-title">Packs Required</h6>
                                      }
                                      <div class="input-group">
                                        @if (selectedStockref[0].width <= 1) {
                                          <input type="text" maxlength="3"
                                            class="form-control fiftypercent" placeholder="Amount required?"
                                            id="qty" inputmode="numeric" pattern="[0-9]*"   digitOnly
                                            formControlName="qty">
                                        }
                                        @if (selectedStockref[0].width > 1.01) {
                                          <input type="text" maxlength="5"
                                            class="form-control fiftypercent" placeholder="Amount required?"
                                            id="qty" inputmode="numeric" digitOnly decimal="true"
                                            formControlName="qty">
                                        }
                                        @if (stockrefPriceQ.price !== 0) {
                                            <button class="btn btn-success"
                                            (click)="addToCart()">Add</button>
                                        }
                                        
                                      </div>
                                    </div>
                                  }
                                </div>
                              </form>
                              @if (selectedStockref) {
                                <div class="table-responsive">
                                  <table class="table">
                                    <thead>
                                      <tr>
                                         @if (selectedStockref[0].width < 1.01) {
                                            <th scope="col">Unit Price</th>
                                         }


                                        
                                        <th scope="col">M2 Price</th>
                                        @if (selectedStockref[0].width > 1.01) {
                                          <th scope="col">Width</th>
                                        }
                                        @if (selectedStockref[0].width <= 1) {
                                          <th scope="col">Pack Size</th>
                                        }
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        @if (stockrefPriceQ) {
                                            @if (selectedStockref[0].width < 1.01) {
                                                <td>£ {{stockrefPriceQ.price }}</td>
                                            }
                                          
                                        }
                                        @if (stockrefPriceQ) {
                                             @if (selectedStockref[0].width < 1.01) {
                                                <td>
                                                £ {{calculateSqmPrice(stockrefPriceQ.price, selectedStockref[0].packSize)}}
                                            </td>
                                             } @else {
                                                <td>£ {{stockrefPriceQ.price }}</td>
                                             }
                                          
                                        }
                                        @if (selectedStockref[0].width > 1.01) {
                                          <td>{{selectedStockref[0].width}} m</td>
                                        }
                                        @if (selectedStockref[0].width <= 1) {
                                          <td>{{selectedStockref[0].packSize}} m2</td>
                                        }
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              }
                            </div>
                          }
                          @if (expressAvailable === false) {
                            <div class="border-product text-center">
                              <h6 class="product-title">Solent Express</h6>
                              <a class="btn btn-default primary-btn">
                              No Express Service Available</a>
                            </div>
                          }
                        </div>
                      }
                      @if (expressCustomer === false;) {
                        <div>
                          <div class="border-product text-center">
                            <h6 class="product-title">SOLENT EXPRESS</h6>
                            <a [routerLink]="['/express/login']" class="btn btn-default primary-btn info">
                            Login To See Prices</a> <br />
                            @if (expressAvailable === true) {
                              <span class="redtext">NATIONWIDE NEXT DAY SERVICE AVAILABLE</span>
                            }
                          </div>
                        </div>
                      }
                      <div class="border-product">
                        <div class="table-responsive">
                          <table class="table">
                            <thead>
                              <tr>
                                <th scope="col">Attributes</th>
                                <th scope="col"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Manufacturer</td>
                                <td>{{ product.manufacturerName }}</td>
                              </tr>
                              @for (attr of product.attributes; track attr) {
                                <tr>
                                  <td>{{ attr.attributeName}}</td>
                                  <td>{{ attr.attributeValue}}</td>
                                </tr>
                              }
                              @if (expressCustomer === true;) {
                                <tr>
                                  <td>Sample</td>
                                  @if (sampleRequest === false;) {
                                    <td> <button (click)="requestSample()" class="btn btn-danger button-border" >
                                      Reqeust sample
                                    </button>
                                  </td>
                                }
                                @if (sampleRequest === true;) {
                                  <td> <button class="btn btn-success button-border" >
                                    Sample Requested
                                  </button>
                                </td>
                              }
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                  @if (product.documents.length) {
                    <div class="border-product">
                      <h6 class="product-title">Downloads</h6>
                      @for (doc of product.documents; track doc) {
                        <a href="{{doc.awsURL}}">
                          <button class="btn btn-success button-border" >
                            <fa-icon class="" [icon]="faFile"></fa-icon> {{doc.name}} <br />
                          </button>
                        </a>
                      }
                    </div>
                  }
                  <div class="border-product">
                    <h6 class="product-title">Share This Page</h6>
                    <share-buttons [theme]="'material-dark'"
                      [include]="['whatsapp', 'email', 'sms', 'copy', 'facebook', 'pinterest', 'x', 'linkedin' ]"
                      [show]="8"
                      [url]="currentURL">
                    </share-buttons>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-xs-12">
              <section class="portfolio-section titles masonray-sec zoom-gallery">
                <div class="filter-section">
                  <div class="container">
                    @if (product.youtube) {
                      <div class="card">
                        <iframe height="296" [src]="product.youtube | safe" frameborder="0"
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                        <div class="card-body">
                          <h4 class="card-title grey">Product Video</h4>
                          <button class="btn btn-danger">YouTube</button>
                        </div>
                      </div>
                    }
                    @for (image of product.colours; track image; let i = $index) {
                      <div class="card">
                        <a (click)="open(i)">
                          <img  [src]="image.awsURL" class="card-img-top autofit">
                        </a>
                        <div class="card-body">
                          <h4 class="card-title grey">{{testSTR(image)}}</h4>
                          @if (image.woodDimensions) {
                            <h5 class="woodtext">{{image.woodDimensions}}</h5>
                          }
                          @if (image.woodFinish) {
                            <h5 class="woodtext">{{image.woodFinish}}</h5>
                          }
                          @if (expressCustomer === true;) {
                            <div>
                              @if (testExpress(image) === true;) {
                                <button class="btn btn-success"
                                (click)="openCartModal(image)">Add To Cart</button>
                              }
                            </div>
                          }
                          @if (expressCustomer === false;) {
                            <div>
                              <a [routerLink]="['/express/login']" class="btn btn-default primary-btn info">
                              Login For Pricing</a>
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-xs-12">
              <section class="portfolio-section titles masonray-sec zoom-gallery">
                <div class="filter-section">
                  <div class="container">
                    @if (relatedProducts?.length) {
                      <h3 class="grey">Related Products</h3>
                    }
                    @for (product of relatedProducts; track product; let i = $index) {
                      <div class="card">
                        <a [routerLink]="['/products/view', product.slug]">
                          <img  [src]="product.mainImageAWSURL" class="">
                        </a>
                        <div class="card-body">
                          <h4 class="card-title grey">{{product.name}}</h4>
                          <p class="card-text">{{product.briefDescription}}</p>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-xs-12">
              <p>We cannot guarantee an exact match in colour and finish, we will not accept any complaints on goods that appear different to the images shown on our website. Samples are available on request and we advise all customers to check goods against a physical sample before ordering
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</div>
}
<!-- Section ends -->
<app-footer></app-footer>
